import React from 'react';
import Icon from '../../../components/AppIcon';

const LodgmentTrackingTable = ({ lodgments, onViewDetails }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed':
        return { icon: 'CheckCircle2', color: 'var(--color-success)' };
      case 'submitted':
        return { icon: 'Clock', color: 'var(--color-info)' };
      case 'pending':
        return { icon: 'AlertCircle', color: 'var(--color-warning)' };
      case 'failed': case'rejected':
        return { icon: 'XCircle', color: 'var(--color-error)' };
      default:
        return { icon: 'FileText', color: 'var(--color-muted-foreground)' };
    }
  };

  const formatCurrency = (amount) => {
    return `K${parseFloat(amount || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getFilingTypeLabel = (type) => {
    switch (type) {
      case 'nasfund':
        return 'NASFUND';
      case 'swt':
        return 'SWT';
      case 'annual_reconciliation':
        return 'Annual Recon';
      default:
        return type;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="List" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Lodgment Tracking History
          </h3>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left">
                <span className="font-heading font-semibold text-sm text-foreground">Type</span>
              </th>
              <th className="px-4 py-3 text-left">
                <span className="font-heading font-semibold text-sm text-foreground">Period</span>
              </th>
              <th className="px-4 py-3 text-right">
                <span className="font-heading font-semibold text-sm text-foreground">Amount</span>
              </th>
              <th className="px-4 py-3 text-center hidden md:table-cell">
                <span className="font-heading font-semibold text-sm text-foreground">Employees</span>
              </th>
              <th className="px-4 py-3 text-left hidden lg:table-cell">
                <span className="font-heading font-semibold text-sm text-foreground">Reference</span>
              </th>
              <th className="px-4 py-3 text-left">
                <span className="font-heading font-semibold text-sm text-foreground">Submitted</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="font-heading font-semibold text-sm text-foreground">Status</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="font-heading font-semibold text-sm text-foreground">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {lodgments?.length === 0 ? (
              <tr>
                <td colSpan="8" className="px-4 py-8 text-center">
                  <div className="flex flex-col items-center gap-2">
                    <Icon name="Inbox" size={32} color="var(--color-muted-foreground)" />
                    <p className="text-sm text-muted-foreground">No lodgments found</p>
                  </div>
                </td>
              </tr>
            ) : (
              lodgments?.map((lodgment) => {
                const statusInfo = getStatusIcon(lodgment?.lodgmentStatus);
                return (
                  <tr key={lodgment?.id} className="hover:bg-muted/50 transition-smooth">
                    <td className="px-4 py-3">
                      <span className="font-body font-medium text-sm text-foreground">
                        {getFilingTypeLabel(lodgment?.filingType)}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className="text-sm text-foreground">{lodgment?.filingPeriod}</span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="data-text font-medium text-sm text-foreground">
                        {formatCurrency(lodgment?.totalAmount)}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center hidden md:table-cell">
                      <span className="text-sm text-muted-foreground">{lodgment?.employeeCount}</span>
                    </td>
                    <td className="px-4 py-3 hidden lg:table-cell">
                      {lodgment?.portalReferenceNumber ? (
                        <span className="data-text text-xs text-foreground font-mono">
                          {lodgment?.portalReferenceNumber}
                        </span>
                      ) : (
                        <span className="text-xs text-muted-foreground">-</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <span className="text-sm text-muted-foreground">
                        {formatDate(lodgment?.submittedAt)}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-center gap-2">
                        <Icon name={statusInfo?.icon} size={16} color={statusInfo?.color} />
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-center">
                        <button
                          onClick={() => onViewDetails?.(lodgment)}
                          className="p-1 hover:bg-muted rounded transition-smooth"
                        >
                          <Icon name="Eye" size={16} color="var(--color-primary)" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LodgmentTrackingTable;
